import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    viaticoId: 0,
    importe: 0,
    observaciones: '',
    rowVersion: null,

    rubros: [],
    totalRubros: 0
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, viaticoId) {
        state.viaticoId = viaticoId;

        state.importe = 0;
        state.observaciones = '';
        state.rowVersion = null;

        state.rubros = [];
        state.totalRubros = 0;
    },
    'SET_RUBROS'(state, viaticoRubros) {
        state.rubros = viaticoRubros.map(viaticoRubro => ({
            id: viaticoRubro.id,
            nombre: viaticoRubro.nombre,
            importe: 0,
            comprobantes: 0
        }))        
    },
    'CALCULAR_TOTAL_RUBROS' (state) {
        state.totalRubros = state.rubros
            .reduce((total, rubro) => total + parseFloat(rubro.importe), 0);
    }
    // 'ADD_RUBRO'(state, viaticoRubro) {
    //     state.rubros.push({
    //         id: viaticoRubro.id,
    //         nombre: viaticoRubro.nombre,
    //         importe: 0,
    //         comprobantes: 0
    //     });
    // },
    // 'REMOVE_RUBRO'(state, viaticoRubroId) {
    //     let itemKey = state.rubros
    //         .findIndex(t => t.id == viaticoRubroId);

    //     if (itemKey != -1) {
    //         state.rubros.splice(itemKey, 1);
    //     }        
    // },
};

const actions = {
    inicializar ( { commit }, viaticoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', viaticoId);
            
            /* Recuperamos los rubros */
            apiAxios.get('viaticos-rubros/list')
                .then(res => {
                    commit('SET_RUBROS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let viaticoRendicionRubros;

            if (state.rubros) {
                if (state.rubros.length != 0) {
                    viaticoRendicionRubros = state.rubros
                        .filter(viaticoRubro => viaticoRubro.importe != 0)
                        .map(viaticoRubro => ({
                            viaticoRubroId: viaticoRubro.id,
                            importe: viaticoRubro.importe,
                            comprobantes: viaticoRubro.comprobantes,
                        }))
                }
            }

            let viaticoRendicion = {
                importe: state.importe,
                observaciones: state.observaciones,
                viaticoRendicionRubros
            };

            apiAxios.post(`viaticos/${state.viaticoId}/rendicion`, viaticoRendicion)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    calcularTotalRubros ( { commit } ) {
        commit('CALCULAR_TOTAL_RUBROS');
    },
    delete ( {}, viaticoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`viaticos/${viaticoId}/rendicion/delete`) 
                .then( () => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    }
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}